import {ConfigProvider, Empty, Select} from 'antd'
import {NullAsDefault} from "views/Shared";
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {useSelector} from 'react-redux'
import EmptyHolder from "../../EmptyHolder";
import {SelectWidget} from "../../../views/AppLocals/custom/ReactSelectComponents";
import LoadingBlock from "../../../views/Loading/LoadingBlock";

// nguồn duy nhất cho danh sách ngôn ngữ toàn hệ thống (khớp config('languages.keys') phía backend)
// - tái dùng ở mọi nơi cần chọn/lọc theo ngôn ngữ, không hardcode lại mảng riêng
export const LANGUAGE_OPTIONS = [
    {id: 'vi', name: 'vi'},
    {id: 'en', name: 'en'},
]

const customizeRenderEmpty = () => (
    <Empty
        imageStyle={{
            height: 60
        }}
        description={
            <span>
        Customize{' '}
                <a href="#API">Description</a>
      </span>
        }
    />
)
export const LanguageSelect = ({
                                   defaultValue,
                                   onChange = NullAsDefault
                               }) => {
    const t = useTranslate()
    const options = LANGUAGE_OPTIONS

    const i18n_lang = useSelector(
        state => state.i18nState?.lang
    )

    const isEmpty = _.isEmpty(options)

    return (
        <ConfigProvider renderEmpty={EmptyHolder}>
            <SelectWidget
                allowClear={true}
                optionFilterProp="label"
                defaultValue={defaultValue || i18n_lang}
                notFoundContent={isEmpty ? <LoadingBlock/> : null}
                loading={isEmpty}
                autoFocus={false}
                placeholder={t('click to select')}
                onChange={onChange}
                style={{width: '100%'}}>
                {options.map(
                    ({id, name}) => (
                        <Select.Option key={id}>
                            {t(name)}
                        </Select.Option>
                    )
                )}
            </SelectWidget>
        </ConfigProvider>
    )
}
